/* eslint-disable react/destructuring-assignment */
import React from '@ali/odin/react';
import styles from './Layout.less';

function BasicLayout(props) {
  return [
    props.children,
    (<footer key={1} className={styles.footer}>
      Copyright © 1998 - 2019 Youku. All Rights Reserved
    </footer>)
  ]
}

export default BasicLayout;
